import { render, staticRenderFns } from "./recordReview.vue?vue&type=template&id=67cda16c&scoped=true&"
import script from "./recordReview.vue?vue&type=script&lang=js&"
export * from "./recordReview.vue?vue&type=script&lang=js&"
import style0 from "./recordReview.vue?vue&type=style&index=0&id=67cda16c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cda16c",
  null
  
)

export default component.exports